<template>
    <v-card tile :height="height" :flat="flat" :style="formTileStyle">
        <v-toolbar
            v-if="showToolbar"
            card
            :dark="isToolbarDark || dark"
            :color="toolbarColor"
            :class="{'elevation-0': flatToolbar}"
        >
            <!-- @slot Additional toolbar actions/content (rendered at the start of the toolbar). -->
            <slot name="toolbar-start"></slot>

            <template v-if="$vuetify.breakpoint.smAndUp">
                <v-toolbar-title v-if="title" :class="{click: showToggleButton}" @click="show = !show">
                    <w-span :color="titleColor" :font-size="titleFontSize">
                        {{title}}
                    </w-span>
                </v-toolbar-title>

                <v-spacer v-if="title"></v-spacer>
            </template>
            <!-- @slot Additional toolbar actions/content (rendered to the RHS of the toolbar). -->
            <slot name="toolbar"></slot>

            <w-btn icon @click="emitClose()" v-if="showClose" icon-name="close"></w-btn>

            <v-tooltip :disabled="!menuTooltip" bottom>
                <!--WMenu Actions-->
                <w-menu
                    slot="activator"
                    v-if="showToolbarMenu"
                    :actions="menuActions"
                    :disabled="menuDisabled"
                    :icon-color="menuIconColor"
                    :icon-name="menuIcon"
                    :open-on-hover="menuOnHover"
                    :title="menuTitle"
                    @select="(action) => handleActionEvent(action)"
                ></w-menu>
                {{menuTooltip}}
            </v-tooltip>

            <w-btn icon @click="show = !show" v-if="showToggleButton"
                   :icon-name="show ? 'arrow_drop_up' : 'arrow_drop_down'"></w-btn>
        </v-toolbar>
        <div v-show="(showToggleButton ? show : true)">
            <slot></slot>
        </div>
    </v-card>
</template>

<script>
    import WBtn from '../WBtn'
    import WSpan from '../WSpan'
    import WCardTileMixin from '../../mixins/w-card-tile-mixin'

    /**
     * Simple tile component.
     */
    export default {
        name: 'WCardTile',
        mixins: [WCardTileMixin],
        components: {
            WBtn,
            WSpan
        },
        data: () => ({
            show: true
        }),
        mounted () {
            const vm = this
            vm.show = Boolean(vm.showValue)
        }
    }
</script>
